import { deepEqual } from '@empathybroker/deep-equal';

import { Route } from 'vue-router';
import { mapActions, mapGetters } from 'vuex';

import { FilterIdEnum } from '../enums';

import { GuardResolveFunction } from '../models';

import { ANALYTICS_CONSTS } from '../store/analytics/analytics.consts';
import { CONTEXT_CONSTS } from '../store/context/context.consts';

export const AnalyticsMixin = {
  computed: {
    ...mapGetters(CONTEXT_CONSTS.moduleName, {
      context: CONTEXT_CONSTS.getters.context
    }),
    ...mapGetters(ANALYTICS_CONSTS.moduleName, {
      selectedId: ANALYTICS_CONSTS.getters.selectedId
    })
  },
  data: function () {
    return {
      contextWatchDisabled: false,
      currentFilters: undefined
    };
  },
  methods: {
    ...mapActions(ANALYTICS_CONSTS.moduleName, {
      clearData: ANALYTICS_CONSTS.actions.clearData,
      setSelectedId: ANALYTICS_CONSTS.actions.setSelectedId
    }),
    loadData: function (): void {}
  },
  beforeRouteLeave: async function (to: Route, from: Route, next: GuardResolveFunction) {
    this.contextWatchDisabled = true;
    await this.clearData();
    if (!!this.selectedId) {
      await this.setSelectedId(undefined);
    }
    next();
  },
  mounted: function (): void {
    this.currentFilters = { ...this.context.filters };
    this.loadData();
  },
  watch: {
    context: {
      handler: async function (): Promise<void> {
        if (!this.contextWatchDisabled) {
          this.currentFilters[FilterIdEnum.COMPARE] = this.context.filters[FilterIdEnum.COMPARE];
          if (!deepEqual(this.context.filters, this.currentFilters)) {
            this.currentFilters = { ...this.context.filters };
            await this.clearData();
          }
          this.loadData();
        }
      },
      deep: true
    }
  }
};
